import type { PubSubCallBack } from '@hotstar/utils';
import type { HttpRequestConfig } from '@hotstar/network';
import { HttpServiceFactory } from '@hotstar/network';
import { CustomHeader } from '../api-constants';

// creating httpInstance
const maxRetryCount = 2;
const options: HttpRequestConfig = {
  headers: {
    [CustomHeader.X_HS_RETRY_COUNT]: '0'
  },
  retry: {
    httpMethods: ['GET', 'PUT', 'HEAD', 'OPTIONS', 'DELETE', 'POST'],
    statusCodes: [[500, 599]],
    strategy: 'exponential',
    max: maxRetryCount
  },
  // timeout for downstream apis should be 2 sec for server and 20s for browser
  timeout: typeof window === 'undefined' ? 2000 : 20000
};

const httpInstance = HttpServiceFactory(options, undefined);

const handleRequestRetryConfigChange: PubSubCallBack = (retriesEnabled: unknown) => {
  if (typeof retriesEnabled !== 'boolean') return;

  const retryCount = retriesEnabled ? maxRetryCount : 0;
  httpInstance.updateConfig({ retry: { max: retryCount } });
};

const getNetworkInstance = () => httpInstance;
const getEmptyNetworkInstance = () => HttpServiceFactory(options);

export {
  httpInstance,
  getNetworkInstance,
  getEmptyNetworkInstance,
  handleRequestRetryConfigChange
};
